<div class="table">
  <div class="hypothesis-title">Hipotesis</div>
  <table>
    <tr>
      <th class="evidence">Evidencia</th>
      <ng-container *ngFor="let value of hypothesis">
        <th class="borders" [matMenuTriggerFor]="menu">
          {{ value.hypothesis }}
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="editHypothesys(value)">
              <span><mat-icon class="edit">edit</mat-icon>Editar</span>
            </button>
            <button mat-menu-item (click)="deleteHypothesys(value)">
              <span><mat-icon class="delete">delete</mat-icon>Eliminar</span>
            </button>
          </mat-menu>
        </th>
      </ng-container>
    </tr>
    <tr *ngFor="let evidence of evidences">
      <td class="borders evidence-item" [matMenuTriggerFor]="menu">
        {{ evidence.evidence }}
        <mat-menu #menu="matMenu">
          <button mat-menu-item (click)="editEvidence(evidence)">
            <span><mat-icon class="edit">edit</mat-icon>Editar</span>
          </button>
          <button mat-menu-item (click)="deleteEvidence(evidence)">
            <span><mat-icon class="delete">delete</mat-icon>Eliminar</span>
          </button>
        </mat-menu>
      </td>
      <td
        *ngFor="let value of hypothesis"
        class="borders value"
        [matMenuTriggerFor]="menu"
      >
        {{ getValue(evidence.id, value.id) }}
        <mat-menu #menu="matMenu" yPosition="above">
          <button mat-menu-item [matMenuTriggerFor]="consistent">
            C - Consistente
          </button>
          <button mat-menu-item (click)="setValue('I', value.id, evidence.id)">
            I - Inconsistente
          </button>
          <button mat-menu-item (click)="setValue('?', value.id, evidence.id)">
            ? - Ambigua
          </button>
        </mat-menu>
        <mat-menu #consistent="matMenu">
          <button mat-menu-item (click)="setValue('C+', value.id, evidence.id)">
            C+
          </button>
          <button mat-menu-item (click)="setValue('C', value.id, evidence.id)">
            C
          </button>
          <button mat-menu-item (click)="setValue('C-', value.id, evidence.id)">
            c-
          </button>
        </mat-menu>
      </td>
    </tr>
  </table>
</div>
